import React from "react";
import {
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  DateInput,
  required,
  BooleanInput
} from "react-admin";
import VideoUpload from "../upload/FileUploader";
import { FormToolbar } from "../../common/FormToolbar";

export const HolidayListCreate = (props) => {
  return (
    <Create title="Holiday Create" {...props}>
      <SimpleForm
        redirect="list"
        toolbar={<FormToolbar {...props} showDelete={false} />}
        variant="outlined"
      >
      <DateInput variant="outlined"  label="Holiday Date" source="date" fullWidth={true}  />
       <TextInput source="name" label='Holiday Name' fullWidth={true} validate={[required()]} />
       <TextInput source="description" label='Description ' fullWidth={true} validate={[required()]}  /> 
       <BooleanInput source="isActive" validate={[required()]} label="Active" />
        
      </SimpleForm>
    </Create>
  );
};
